<template>
  <NavigationLayout
    :navigationTitle="$t('personalInfo2')"
    :navigationBarStyle="{
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigationContentStyle="{
      'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
    }"
  >
    <div id="personal__wrapper" slot="contents">
      <ValidationObserver v-slot="{ invalid }" ref="observer">
        <div id="personal__container">
          <section>
            <ValidationProvider rules="required|max:30" v-slot="{ errors }">
              <div class="list_item__container">
                <div class="list_item__content list_item__element">
                  <div class="list_item__title">{{ $t('firstName') }}</div>
                </div>
                <div class="list_item__action list_item__element">
                  <input
                    v-model="firstName"
                    v-bind:style="{ minWidth: '200px' }"
                    type="text"
                    placeholder="hanako"
                    size="8"
                    required
                  />
                </div>
              </div>
              <div class="error__messages">
                <span v-for="(error, index) in errors" :key="index">
                  <p v-if="error !== undefined">{{ error }}</p>
                </span>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|max:30" v-slot="{ errors }">
              <div class="list_item__container">
                <div class="list_item__content list_item__element">
                  <div class="list_item__title">{{ $t('lastName') }}</div>
                </div>
                <div class="list_item__action list_item__element">
                  <input
                    v-model="lastName"
                    v-bind:style="{ minWidth: '200px' }"
                    type="last_name"
                    placeholder="yamada"
                    required
                  />
                </div>
              </div>
              <div class="error__messages">
                <span v-for="(error, index) in errors" :key="index">
                  <p v-if="error !== undefined">{{ error }}</p>
                </span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required|country_region|max:10"
              v-slot="{ errors }"
            >
              <div class="list_item__container">
                <div class="list_item__content list_item__element">
                  <div class="list_item__title">{{ $t('countryRegion') }}</div>
                </div>
                <select
                  v-model="region"
                  v-bind:style="{ minWidth: '100px' }"
                  name="region"
                  required
                >
                  <option value="">--- Please select ---</option>
                  <option
                    v-for="(region, index) in regions"
                    :key="index"
                    :value="index"
                  >
                    {{ region }}
                  </option>
                </select>
              </div>
              <div class="error__messages">
                <span v-for="(error, index) in errors" :key="index">
                  <p v-if="error !== undefined">{{ error }}</p>
                </span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required|email|confirmed:confirmationEmail"
              v-slot="{ errors }"
            >
              <div class="list_item__container">
                <div class="list_item__content list_item__element">
                  <div
                    class="list_item__title"
                    v-bind:style="ListItemStyleSectionLast"
                  >
                    {{ $t('email') }}
                  </div>
                </div>
                <div class="list_item__action list_item__element">
                  <input
                    v-model="email"
                    v-bind:style="{ minWidth: '300px' }"
                    type="email"
                    placeholder="reality@example.com"
                    required
                  />
                </div>
              </div>
              <div class="error__messages">
                <span v-for="(error, index) in errors" :key="index">
                  <p v-if="error !== undefined">{{ error }}</p>
                </span>
              </div>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" vid="confirmationEmail">
              <div class="list_item__container">
                <div class="list_item__content list_item__element">
                  <div
                    class="list_item__title"
                    v-bind:style="ListItemStyleSectionLast"
                  >
                    {{ $t('confirmationEmail') }}
                  </div>
                </div>
                <div class="list_item__action list_item__element">
                  <input
                    v-model="confirmationEmail"
                    v-bind:style="{ minWidth: '300px' }"
                    type="email"
                    placeholder="reality@example.com"
                    required
                  />
                </div>
              </div>
              <div class="error__messages">
                <span v-for="(error, index) in errors" :key="index">
                  <p v-if="error !== undefined">{{ error }}</p>
                </span>
              </div>
            </ValidationProvider>
          </section>
          <div>
            <div v-bind:style="CautionsStyle">
              <p>{{ $t('pleaseRegisterYourPersonalInformation') }}</p>
              <p>
                {{ $t('handlingOfWisePersonalInformation') }}
              </p>
            </div>
          </div>
          <section id="personal__submit">
            <ButtonSubmit
              id="personal__submit_button"
              :title="$t('register')"
              v-bind:disabled="invalid"
              v-on:click.native="submit"
            />
          </section>
        </div>
      </ValidationObserver>
    </div>
  </NavigationLayout>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { LanguageQueryHandler } from '@/mixins/LanguageQuery'
import NavigationLayout from '@/components/NavigationLayout.vue'
import ListItem from '@/components/ListItem.vue'
import ButtonSubmit from '@/components/ButtonSubmit.vue'
import SubmitNotification from '@/components/SubmitNotification.vue'
import MypageStyle from '@/styles/mypage'
import { getCountryNames, getCountryName } from '@/utils/countries'
import {
  ValidationObserver,
  ValidationProvider,
} from '../../../../utils/validation'
import { apiV2 } from '@/api/appGatewayServerV2Api'
import { handleUnauthorized } from '@/utils/handle_error'
import { checkInMaintenance } from '@/utils/maintenance'

@Component({
  components: {
    NavigationLayout,
    ListItem,
    SubmitNotification,
    ButtonSubmit,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Wise extends Mixins(LanguageQueryHandler) {
  CautionsStyle = MypageStyle.Cautions
  ListItemStyleSectionLast = MypageStyle.ListItemSectionLast

  isEnabledRegisterBtn: boolean = false //default

  regions: { [key: string]: string } = {}

  lastName: string = ''
  firstName: string = ''
  region: string = ''
  email: string = ''
  confirmationEmail: string = ''

  errorMessages: { field: string; message: string }[] = []

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>
  }

  async created() {
    // TODO:ここで地域チェックを行う（後日実装）

    // 国一覧を取得
    this.regions = getCountryNames()

    try {
      // ユーザー情報を取得
      await this.fetchWiseAccount()
    } catch (e) {
      if (checkInMaintenance(e)) {
        // メンテの場合はそのままメンテ中画面へリダイレクト
        this.$router.push({ path: '/maintenance' }).catch(() => {})
        return
      }
      handleUnauthorized(e)
    }
  }

  async fetchWiseAccount() {
    const res = await apiV2().wiseAccount.get()
    this.firstName = res.firstName
    this.lastName = res.lastName
    this.region = res.region
    this.email = res.email
  }

  async submit() {
    // 送信前にバリデーションを行う
    const isVlid = this.$refs.observer.validate()
    if (!isVlid) {
      alert(this.$t('validationCommonErrorMessage'))
      return
    }

    // confirmのメッセージを作成
    const finalConfirmation = '【' + this.$t('finalConfirmation') + '】'
    const firstNameLabel = this.$t('firstName') + ': '
    const lastNameLabel = this.$t('lastName') + ': '
    const regionLabel = this.$t('countryRegion') + ': '
    const emailLabel = this.$t('email') + ': '

    const message =
      finalConfirmation +
      '\n\n' +
      firstNameLabel +
      this.firstName +
      '\n' +
      lastNameLabel +
      this.lastName +
      '\n' +
      regionLabel +
      getCountryName(this.region) +
      '\n' +
      emailLabel +
      this.email

    // 確認画面がないので代わりにここで最終確認を行う
    if (!confirm(message + '\n\n' + this.$t('registrationConfirmation'))) {
      return
    }

    try {
      // 登録処理
      await apiV2().wiseAccount.store({
        firstName: this.firstName,
        lastName: this.lastName,
        region: this.region,
        email: this.email,
      })
      alert(this.$t('registrationCompleted'))
      this.fetchWiseAccount()
    } catch (e) {
      console.error(e) // eslint-disable-line no-console
      alert(this.$t('errorGeneral'))
    }
  }
}
</script>

<style scoped>
#personal__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
  background-color: #fafafa;
}
#personal__container {
  padding-top: 20px;
  padding-bottom: 49px;
}

#personal__container input {
  min-width: 144px;
  width: auto;
}

#personal__submit {
  margin-top: 40px;
}
#personal__submit_button {
  width: 224px;
  height: 44px;
  display: table;
  margin: auto;
}

/* error messages */
.error__messages {
  padding: 0 16px;
  margin-bottom: 20px;
  font-family: sans-serif;
  font-size: 14px;
  color: #f73d59;
}

/** list item */
.list_item__container {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: #e8e8e8 solid 1px;
  border-collapse: collapse;
  background-color: #ffffff;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
}

.list_item__container.list_item__container_warning {
  color: #f73d59;
  border: 1px #f73d59 solid;
}

.list_item__element {
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 12px;
  margin-bottom: 12px;
}

.list_item__content {
  align-self: start;
  padding-top: 0px;
  padding-left: 16px;
}
.list_item__action {
  text-align: right;
  padding-right: 16px;
}
.list_item__action_disclosure {
  color: rgba(0, 0, 0, 0.25);
  font-weight: bold;
  margin-left: 8px;
}
.list_item__action_live_point {
  margin-top: 12px;
  margin-bottom: 12px;
}

/* mypage */
input {
  font-size: 14px;
  color: #262626;
}
select {
  direction: rtl;
  font-size: 14px;
  color: #262626;
}

input,
select {
  text-align: right;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 0;
  outline: none;
  background: none;
  line-height: 1.43;
}
</style>
